export const UPDATE_ANSWER = 'assessments/UPDATE_ANSWER'
export const UPDATE_CHECK = 'assessments/UPDATE_CHECK'

export function updateAnswer(levelId,indicatorId,store) {
              //let answers = selectedAssessment.answers
            //console.log(selectedAnswers)
    return (dispatch, getState) => {
            const activityId = getState().selectedActivity.id 
            
            let assessment = getState().selectedAssessment 
            let answers = assessment.answers

            const found = answers.find( answer => answer.activityId === activityId && answer.levelId === levelId)
            if (!found) {
                answers.push({ activityId, levelId, indicatorId })
            } else {
                answers = answers.map( answer => {
                    if (answer.activityId === activityId && answer.levelId === levelId) {
                        answer.indicatorId = indicatorId
                    }
                    return answer
                })
            }
            store.firestore.update({ collection:'assessmentsByRater', doc: assessment.id },{answers: answers})
                .then(data => {  
                    assessment.answers = answers
                    dispatch({type: UPDATE_ANSWER,assessment})
                    return data })
                .catch(error => {
                    dispatch({type: 'ERROR', levelId: levelId ,message: error })
                })  
    }
}

/**
 * Used by checkbox indicators only
 * @param {*} index 
 * @param {*} isChecked 
 * @param {*} levelId 
 * @param {*} store 
 */
export function updateCheck(index,isChecked,levelId,store) {
    return (dispatch, getState) => {
        const activityId = getState().selectedActivity.id 
        

        let assessment = getState().selectedAssessment 
        let answers = assessment.answers


        const found = answers.find( answer => answer.activityId === activityId && answer.levelId === levelId)
        if (!found) {            
            const checked = { 0: false, 1: false, 2: false }
            checked[index + ''] = true
            answers.push({ activityId, levelId, checked })
        } else {
            answers = answers.map( answer => {
                if (answer.activityId === activityId && answer.levelId === levelId) {
                    if (!answer.checked) { 
                        answer.checked = { 0: false, 1: false, 2: false }
                    }
                    answer.checked[index + ''] = isChecked
                }

                return answer
            })
        }
        assessment.answers = answers

        store.firestore.update({ collection:'assessmentsByRater', doc: assessment.id },{answers: answers}) 


        dispatch({type: UPDATE_CHECK,answer: found})
    }    
}


// WEBPACK FOOTER //
// ./src/indicators/actions.js